import dynamic from "next/dynamic";
import DeliveryAddressForm from "@/components/location/DeliveryAddressForm";
import styles from "./styles.module.scss";
import { PortableText } from "@portabletext/react";
import { portableTextComponents } from "@/lib/portableTextComponents";
import { Tags } from "@/components/tags/Tags";

const LeafletMap = dynamic(() => import("../../map/deliveryMap"), {
  ssr: false,
  loading: () => (
    <div className="bg-neutral-250 w-100 flex align-center justify-content-center br-300">
      Loading Map...
    </div>
  ),
});

export function DeliveryMap({
  deliveryZips,
  title,
  titleColor,
  subtitle,
  subtitleColor,
  content,
  tags,
}) {

  return (
    <section className={styles.section}>
      <div className={styles.contentWrapper}>
        {title && (
          <h2
            className={styles.title}
            style={
              titleColor
                ? {
                    color: `rgba(${titleColor.rgb.r},${titleColor.rgb.g},${titleColor.rgb.b},${titleColor.rgb.a})`,
                  }
                : {}
            }
          >
            {title}
          </h2>
        )}
        {subtitle && (
          <h3
            className={styles.subtitle}
            style={
              subtitleColor
                ? {
                    color: `rgba(${subtitleColor.rgb.r},${subtitleColor.rgb.g},${subtitleColor.rgb.b},${subtitleColor.rgb.a})`,
                  }
                : {}
            }
          >
            {subtitle}
          </h3>
        )}
        {tags && <Tags tags={tags} wrapperStyles={styles.tags} />}
        {content && (
          <div className={styles.content}>
            <PortableText value={content} components={portableTextComponents} />
          </div>
        )}
        <DeliveryAddressForm storeSuccessMessage={true} />
      </div>

        <div className={styles.mapWrapper}>
        {deliveryZips && <LeafletMap zipcodes={deliveryZips} />}
        </div>
 
    </section>
  );
}
